import type { ZudokuConfig } from "zudoku";

/**
 * Developer Portal Configuration
 * For more information, see:
 * https://zuplo.com/docs/dev-portal/zudoku/configuration/overview
 */
const config: ZudokuConfig = {
  site: {
    //title: "SLAMai | The Intelligence Engine for Autonomous Web3",
    title: "",
    logo: {
      src: {
        light: "https://chain-explorer.s3.us-east-1.amazonaws.com/SLAMai-light-small8.png",
        dark: "https://chain-explorer.s3.us-east-1.amazonaws.com/SLAMai-dark-small8.png",
      },
    },
  },
  metadata: {
    title: "SLAMai | The Intelligence Engine for Autonomous Web3",
    description: "From WalletDNA to DeFi and NFTs, SLAMai powers agents, apps, and protocols with real-time behavioral and market intelligence.",
    favicon: "https://chain-explorer.s3.us-east-1.amazonaws.com/SLAMaiIcon.ico"
  },
  theme: {
    fonts: {
      sans: "Space Grotesk",
      serif: "Merriweather",
      mono: "JetBrains Mono",
    },
    customCss: `
    a[href="https://zudoku.dev"] {
      display: none !important;
    }

     /* Sidebar method chips */
  nav span.uppercase.text-\\[0\\.65rem\\].font-bold.rounded-sm {
    display: none !important;
  }

  /* Endpoint page method chip */
  article span.uppercase.text-\\[0\\.65rem\\].font-bold.rounded-sm {
    display: none !important;
  }

  /* Paranoid fallback: any chip with that bracket-size + chipy classes */
  span[class*="uppercase"][class*="text-\\[0\\.65rem\\]"][class*="rounded-sm"][class*="px-1"] {
    display: none !important;
  }

  /* If some use explicit green classes, kill those too */
  span.uppercase.text-green-500,
  .dark span.uppercase.dark\\:text-green-600 {
    display: none !important;
  } 

  `,
    dark: {
      background: '#000B1B',
      foreground: '#F2F5F9',

      card: '#111623',
      cardForeground: '#E0E4EC',

      popover: '#141B2D',
      popoverForeground: '#F2F5F9',

      primary: '#F2F5F9',
      primaryForeground: '#0B0F19',

      secondary: '#121824',
      secondaryForeground: '#B3BCD9',

      muted: '#1A1F2B',
      mutedForeground: '#DDE2EB',

      accent: '#293750',
      accentForeground: '#E0E4EC',

      destructive: '#EF4444',
      destructiveForeground: '#FFFFFF',

      border: '#2A3144',
      input: '#1D2433',
      ring: '#3B82F6',

      radius: '0.375rem'
    }
  },

  navigation: [
    {
      type: "link",
      to: "/api",
      label: "Intelligence API",
      icon: "code",
    },
    // {
    //   type: "link",
    //   to: "/nft-api",
    //   label: "NFT API",
    //   icon: "image",
    // },
    {
      type: "category",
      label: "MCP Server",
      icon: "bot",
      items: [
        { type: "doc", file: "mcp/overview", label: "Overview", icon: "layout-dashboard" },
        {
          type: "category", label: "Tools", collapsible: false, icon: "wrench",
          items: [
            { type: "doc", file: "mcp/token-discovery", label: "TokenDiscovery", icon: "search-code" },
            { type: "doc", file: "mcp/token-price", label: "TokenPrice", icon: "trending-up" },
            { type: "doc", file: "mcp/token-transfers", label: "TokenTransfers", icon: "arrow-right-left" },
            { type: "doc", file: "mcp/token-swaps", label: "TokenSwaps", icon: "arrow-right-left" }
          ]
        }
      ]
    },
    {
      type: "category",
      label: "WalletDNA",
      icon: "dna",
      items: [
        { type: "doc", file: "dna/overview", label: "Overview", icon: "layout-dashboard" },
        { type: "doc", file: "dna/iq", label: "IQ", icon: "brain" },
        { type: "doc", file: "dna/reputation", label: "Reputation", icon: "medal" },
        { type: "doc", file: "dna/flow", label: "Flow", icon: "waves" },
        { type: "doc", file: "dna/epoch", label: "Epoch", icon: "hourglass" },
        { type: "doc", file: "dna/mass", label: "Mass", icon: "fish" },
        { type: "doc", file: "dna/presence", label: "Maker Presence", icon: "repeat" }
      ]
    },
    {
      type: "category",
      label: "SLAM Nation",
      icon: "zap",
      items: [
        { type: "doc", file: "slam-nation/overview", label: "Overview", icon: "scroll" },
        { type: "doc", file: "slam-nation/join", label: "Join", icon: "circle-plus" }
      ]
    },
    {
      type: "category",
      label: "x402",
      icon: "coins",
      items: [
        { type: "doc", file: "x402/overview", label: "Overview", icon: "layout-dashboard" }
      ]
    },
    /*{
    type: "link",
    to: "/pricing",
    label: "Pricing",
    icon: "coins",
   },
  {
    type: "link",
    to: "/slam",
    label: "SLAM Token",
    icon: "zap",
  }*/
  ],
  redirects: [
    { from: "/", to: "https://slamai.xyz" },
  ],
  apis: [
    {
      type: "file",
      input: "../config/routes.oas.json",
      path: "api",
    },
    {
      type: "file",
      input: "../config/nft.oas.json",
      path: "nft-api",
    }
  ],

  // authentication: {
  // // IMPORTANT: This is a demo Auth0 configuration.
  // // In a real application, you should replace these values with your own
  // // identity provider's configuration.
  // // This configuration WILL NOT WORK with custom domains.
  // // For more information, see:
  // // https://zuplo.com/docs/dev-portal/zudoku/configuration/authentication
  //   type: "auth0",
  //   domain: "auth.zuplo.site",
  //   clientId: "f8I87rdsCRo4nU2FHf0fHVwA9P7xi7Ml",
  //   audience: "https://api.example.com/",
  // },
  apiKeys: {
    enabled: true,
  },
  search: {
    type: "pagefind",
    // Optional: Maximum number of sub results per page
    maxSubResults: 5,
    // Optional: Configure search result ranking (defaults shown below)
    ranking: {
      termFrequency: 0.8,
      pageLength: 0.6,
      termSimilarity: 1.2,
      termSaturation: 1.2,
    },
  },

  defaults: {
    apis: {
      transformExamples: ({ content, auth }) => {
        return content.map((contentItem) => ({
          ...contentItem,
          example: {
            ...contentItem.example,
            headers: {
              "Authorization": "Bearer <YOUR_API_KEY>",
            },
          },
        }));
      }
    },
  },
};

export default config;
